import React, {useRef, useState} from 'react'
import BulkMessageBox from '../Components/BulkMessageBox'
import {useDispatch, useSelector} from 'react-redux'
import {getDedicatedNumber} from '../../../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import GiphyPopup from '../../../../Common/GiphyPopup/GiphyPopup'
import Select from 'react-select'
import {countWords} from '../../../../../../_metronic/helpers'
import MessageBoxV2 from '../../../../../Components/MessageBoxV2'
import WSButton from '../../../../../../_metronic/helpers/components/WSButton/WSButton'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {BulkMsgDraftData} from '../../BulkMessageSlice/BulkMessageSlice'
import {fileToBase64, processData} from '../../../../../Utils/_helpers'
import {globalSettingsTypes} from '../../../../../Utils/Constant/status'
import MessageBoxSecond from '../../../../../Components/MessageBoxSecond'
import {getAllUserDetails} from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useNewMessage} from '../../useNewMessage'
import { REGION } from '../../../../../Utils/Constant/ConstantForWebsite'

const Bulk_Message_MesssageBox = ({
  bulkMessageData,
  setBulkMessageData,
  checkStep,
  setMMSError,
  error,
  setError,
}: any) => {
  const dispatch = useDispatch()
  const DedicatedNumber: any = useSelector(getDedicatedNumber)
  const userGlobalSetting = useSelector(
    (state: any) => state?.userDetails?.userDetails?.data?.user?.globalSetting
  )
  const userValues = useSelector(getAllUserDetails)
  const {isDefaultRegion, currentRegion} = useNewMessage()

  const mediaInput: any = useRef(null)
  const mediaInputVideo: any = useRef(null)

  const hasCustomPriceSetting =
    userGlobalSetting && userGlobalSetting?.includes(globalSettingsTypes.SEND_WITH_CUSTOM_PRICE)
  const isSenderBusinessNameOrCustomNumber =
    bulkMessageData?.senderType === 'businessName' || bulkMessageData?.senderType === 'customNumber'

  const isCustomPriceOrAlphaId = hasCustomPriceSetting
    ? isSenderBusinessNameOrCustomNumber
    : !userGlobalSetting && isSenderBusinessNameOrCustomNumber

  const [giphypopup, setGiphypopup] = useState<any>(false)
  const [popup, setPopup] = useState(false)
  const [uploadLimit, setUploadLimit] = useState('')
  const [options, setOptions] = useState({
    webLink: [
      {
        value: '',
        label: (
          <button
            onClick={() => {
              setPopup(true)
            }}
          >
            Create
          </button>
        ),
      },
    ],
    customLanding: [
      {
        value: '',
        label: (
          <button
            onClick={() => {
              window.open('/create-langing-page')
            }}
          >
            Create
          </button>
        ),
      },
    ],
    optOut: [
      {
        value: '',
        label: (
          <button
            onClick={() => {
              window.open('/opt-out')
            }}
          >
            Create
          </button>
        ),
      },
      {value: 'ReplyStop', label: 'Reply Stop'},
    ],
  })
  const optoutCount = bulkMessageData.optout === true ? 22 : 0
  const replyStopToOptOutCount = bulkMessageData.replyStopToOptOut === true ? 15 : 0

  const optoutCountSecond = bulkMessageData.optoutSecond === true ? 22 : 0
  const replyStopToOptOutCountSecond = bulkMessageData.replyStopToOptOutSecond === true ? 15 : 0

  return (
    <>
      <GiphyPopup
        // setUploadLimit={setUploadLimit}
        data={bulkMessageData}
        setData={setBulkMessageData}
        show={giphypopup}
        bulkMessage={true}
        handleClose={() => {
          setGiphypopup(false)
        }}
      />
      <h2
        className={`accordion-header ${
          bulkMessageData.message !== '' && bulkMessageData.camp_type !== '' && 'successData'
        }`}
        id='headingfour'
      >
        <button
          className='accordion-button collapsed'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapsefour'
          aria-expanded='false'
          aria-controls='collapsefour'
        >
          Message
        </button>
        <div className='bulk-message-collapse'>
          {bulkMessageData?.message?.length > 0 ? (
            <div className='accordion-title-detail small'>
              {bulkMessageData?.abTest === true && <div className='mb-2'>Message A: </div>}
              Characters:{' '}
              {(bulkMessageData.camp_type === 'sms') !== true ? (
                <strong>{`${
                  // countWords(bulkMessageData?.message) + replyStopToOptOutCount + optoutCount
                  countWords(bulkMessageData?.message)
                }/1000`}</strong>
              ) : (
                <strong>{`${
                  processData(
                    bulkMessageData?.message ?? '',
                    replyStopToOptOutCount + optoutCount,
                    isCustomPriceOrAlphaId
                  )?.length
                }/${
                  processData(
                    bulkMessageData?.message ?? '',
                    replyStopToOptOutCount + optoutCount,
                    isCustomPriceOrAlphaId
                  )?.maxdata
                }`}</strong>
              )}{' '}
              | {bulkMessageData.camp_type?.toUpperCase()} Credits:{' '}
              {(bulkMessageData.camp_type === 'sms') !== true ? (
                <strong> 1</strong>
              ) : (
                <strong>
                  {' '}
                  {
                    processData(
                      bulkMessageData?.message ?? '',
                      replyStopToOptOutCount + optoutCount,
                      isCustomPriceOrAlphaId
                    )?.credit
                  }
                </strong>
              )}
            </div>
          ) : (
            <div className='accordion-title-detail small'>Write your message</div>
          )}

          {bulkMessageData?.abTest === true && (
            <>
              {bulkMessageData?.messageSecond?.length > 0 ? (
                <div className='accordion-title-detail small'>
                  <div className='mb-2'>Message B: </div>
                  Characters:{' '}
                  {(bulkMessageData.camp_type === 'sms') === true && (
                    <strong>{`${
                      processData(
                        bulkMessageData?.messageSecond ?? '',
                        replyStopToOptOutCountSecond + optoutCountSecond,
                        isCustomPriceOrAlphaId
                      )?.length
                    }/${
                      processData(
                        bulkMessageData?.messageSecond ?? '',
                        replyStopToOptOutCountSecond + optoutCountSecond,
                        isCustomPriceOrAlphaId
                      )?.maxdata
                    }`}</strong>
                  )}{' '}
                  | {bulkMessageData.camp_type?.toUpperCase()} Credits:{' '}
                  {(bulkMessageData.camp_type === 'sms') === true && (
                    <strong>
                      {' '}
                      {
                        processData(
                          bulkMessageData?.messageSecond ?? '',
                          replyStopToOptOutCountSecond + optoutCountSecond,
                          isCustomPriceOrAlphaId
                        )?.credit
                      }
                    </strong>
                  )}
                </div>
              ) : (
                <div className='accordion-title-detail small'>Write your second message</div>
              )}
            </>
          )}
          {/* <button
            type='button'
            className=' btn-toggle-bulk'
            data-bs-toggle='collapse'
            data-bs-target='#collapsefour'
            aria-expanded='false'
            aria-controls='collapsefour'
          >
            Click
          </button> */}
        </div>
      </h2>
      <div
        id='collapsefour'
        className={`accordion-collapse collapse ${checkStep.message && 'show'}`}
        aria-labelledby='headingfour'
        data-bs-parent='#accordionExample'
      >
        <div className='accordion-body'>
          <div className='d-flex mb-2'>
            <div
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              title={
                DedicatedNumber?.find(
                  (key: any) => key.audNumber === bulkMessageData.sender?.value
                )?.type?.toLowerCase() === 'mms'
                  ? 'To select SMS , First select from Dedicated  number of type SMS '
                  : ''
              }
              className=' me-3 w-auto mw-150px'
            >
              <input
                type='radio'
                className='btn-check'
                name='radio_buttons_2'
                value='sms'
                id='kt_radio_buttons_2_option_2'
                // disabled={
                //   DedicatedNumber?.find(
                //     (key: any) => key.audNumber === bulkMessageData.sender?.value
                //   )?.type?.toLowerCase() === 'mms'
                // }
                checked={bulkMessageData.camp_type === 'sms'}
                onChange={() => {
                  let tempData = {
                    ...bulkMessageData,
                    camp_type: 'sms',
                    optoutLabel: '',
                    optoutId: '',
                  }
                  if (bulkMessageData.senderType === 'dedicatedNumber') {
                    tempData = {
                      ...tempData,
                    }
                  }
                  setBulkMessageData(tempData)

                  dispatch(
                    BulkMsgDraftData({
                      ...tempData,
                      scheduledAt: '',
                    })
                  )
                }}
              />
              <label
                className='btn btn-outline btn-outline-dashed btn-outline-default p-4 px-7 d-flex align-items-center justify-content-center'
                htmlFor='kt_radio_buttons_2_option_2'
                data-testid='btnSMSMessage'
              >
                SMS
              </label>
            </div>
            <div
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              title={
                DedicatedNumber?.find(
                  (key: any) => key.audNumber === bulkMessageData.sender?.value
                )?.type?.toLowerCase() === 'sms'
                  ? 'To select MMS , First select from Dedicated  number of type MMS  '
                  : ''
              }
              className='  w-auto mw-150px'
            >
              <input
                type='radio'
                className='btn-check'
                name='radio_buttons_2'
                value='apps'
                id='kt_radio_buttons_2_option_1'
                disabled={
                  DedicatedNumber?.find(
                    (key: any) => key.audNumber === bulkMessageData.sender?.value
                  )?.type?.toLowerCase() === 'sms'
                }
                checked={bulkMessageData.camp_type === 'mms'}
                onChange={() => {
                  let tempData = {
                    ...bulkMessageData,
                    camp_type: 'mms',
                    optoutLabel: '',
                    optoutId: '',
                  }
                  if (
                    bulkMessageData.senderType === 'businessName' ||
                    bulkMessageData.senderType === 'customNumber' ||
                    bulkMessageData.senderType === 'dedicatedNumber'
                  ) {
                    if (
                      DedicatedNumber?.find(
                        (key: any) => key.audNumber === bulkMessageData.sender?.value
                      )?.type?.toLowerCase() === 'sms'
                    ) {
                      tempData.sender = ''
                      tempData.senderType = ''

                      setError({...error, sender: 'Select sender  is required'})
                      setMMSError(true)
                    }
                  }
                  setBulkMessageData(tempData)
                  dispatch(
                    BulkMsgDraftData({
                      ...tempData,
                      scheduledAt: '',
                    })
                  )
                }}
              />
              {[REGION.US, REGION.UK, REGION.AU].includes(currentRegion) ? (
                <OverlayTrigger
                  placement='top'
                  overlay={
                    <Tooltip id='button-tooltip'>
                      MMS can not be sent with customer business name or your own number
                    </Tooltip>
                  }
                >
                  <label
                    className='btn btn-outline btn-outline-dashed btn-outline-default p-4 px-7 d-flex align-items-center justify-content-center'
                    htmlFor='kt_radio_buttons_2_option_1'
                    data-testid='btnMMSMessage'
                  >
                    MMS
                  </label>
                </OverlayTrigger>
              ) : null}
            </div>
          </div>
          <div className='tab-content' id='myTabContent'>
            <div
              className='tab-pane fade show active'
              id='sms'
              role='tabpanel'
              aria-labelledby='sms-tab'
            >
              {bulkMessageData?.camp_type === 'mms' && (
                <>
                  <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                    <div className='mt-0'>
                      <label className='form-label'>Subject line</label>
                      <input
                        type='text'
                        data-testid='inputSubjectMMS'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Type optional subject line here'
                        value={bulkMessageData?.subject}
                        onChange={(e: any) => {
                          setBulkMessageData({...bulkMessageData, subject: e?.target?.value})
                          dispatch(
                            BulkMsgDraftData({
                              ...bulkMessageData,
                              scheduledAt: '',
                              subject: e?.target?.value,
                            })
                          )
                        }}
                      />
                    </div>
                  </div>
                  <div className='col-xl-4 col-lg-5 col-md-6 col-sm-12 mt-8 mb-4'>
                    <div className=' d-flex flex-column media_dropdown'>
                      <label className='form-label'>Media</label>
                      <input
                        ref={mediaInput}
                        accept={'.jpeg,.png,.vcf'}
                        type='file'
                        name='file'
                        data-testid='inputUploadMedia'
                        style={{display: 'none'}}
                        onChange={async (e: any) => {
                          let data = e.target.files[0]
                          let err = {...error}
                          delete err?.media
                          data?.size > 1048576 &&
                            setError({
                              ...error,
                              media: 'Upload size should be less than 1mb',
                            })
                          if (data && data?.size < 1048576) {
                            let base64String = bulkMessageData?.media ?? ''
                            if (!!data && !(typeof data == 'string')) {
                              base64String = await fileToBase64(data)
                            }
                            setBulkMessageData({...bulkMessageData, media: data, gif: ''})
                            dispatch(
                              BulkMsgDraftData({
                                ...bulkMessageData,
                                scheduledAt: '',
                                media: base64String,
                                gif: '',
                              })
                            )
                          }
                          setError(err)
                        }}
                      />
                      <input
                        ref={mediaInputVideo}
                        accept={'.jpeg,.png,.jpg,.gif,.mp4,.mp3,video/*,.vcf'}
                        type='file'
                        name='file'
                        data-testid='inputUploadGif'
                        style={{display: 'none'}}
                        onChange={async (e: any) => {
                          let data = e.target.files[0]
                          let err = {...error}
                          delete err?.media

                          data?.size > 1048576 &&
                            setError({
                              ...error,
                              media: 'Upload size should be less than 1mb',
                            })

                          if (data && data?.size < 1048576) {
                            let base64String = bulkMessageData?.media ?? ''
                            if (!!data && !(typeof data == 'string')) {
                              base64String = await fileToBase64(data)
                            }
                            setBulkMessageData({...bulkMessageData, media: data, gif: ''})
                            dispatch(
                              BulkMsgDraftData({
                                ...bulkMessageData,
                                scheduledAt: '',
                                media: base64String,
                                gif: '',
                              })
                            )
                            setError(err)
                          }
                        }}
                      />
                      <Select
                        value={{value: '', label: 'Add media'}}
                        placeholder='Add Media'
                        isSearchable={false}
                        onChange={(e: any) => {
                          // if (e.value == '1') {
                          //   mediaInput.current.click()
                          // }
                          if (e.value == '1') {
                            mediaInputVideo.current.click()
                          }
                          if (e.value == '3') {
                            setGiphypopup(true)
                          }
                        }}
                        options={[
                          {value: '1', label: 'Upload File'},
                          // {value: '2', label: 'Upload video'},
                          {value: '3', label: 'Select GIPHY'},
                        ]}
                      />
                      <p
                        style={{
                          whiteSpace: 'nowrap',
                        }}
                        className='m-0 text-muted pt-2'
                      >
                        File size should be less than 1 MB.
                      </p>

                      {(bulkMessageData?.media !== '' || bulkMessageData.gif !== '') && (
                        <span className='text-muted fs-7 d-flex flex-row mb-0 mt-3'>
                          Media selected:
                          {bulkMessageData.media !== '' && bulkMessageData.media?.name}
                          {bulkMessageData.gif !== '' && 'GIF'}{' '}
                          <span className='text-dark fs-7 ms-1 mb-2'></span>
                          <span className='ms-2'>
                            <WSButton
                              type='button'
                              className={
                                'btn btn-sm btn-icon btn-light btn-light-danger fw-500 fs-7 h-100 mh-20px w-20px d-flex justify-content-center align-items-center'
                              }
                              onClick={() => {
                                mediaInput.current.value = null
                                mediaInputVideo.current.value = null
                                setBulkMessageData({...bulkMessageData, media: '', gif: ''})
                                dispatch(
                                  BulkMsgDraftData({
                                    ...bulkMessageData,
                                    scheduledAt: '',
                                    media: '',
                                    gif: '',
                                  })
                                )
                              }}
                              iconPath='/media/icons/duotune/arrows/arr061.svg'
                              iconClass='svg-icon-8 mb-1'
                            />
                          </span>
                        </span>
                      )}
                    </div>
                  </div>
                  {error?.media && (
                    <p style={{color: 'red'}} className='mb-2'>
                      {error?.media}
                    </p>
                  )}
                </>
              )}

              {isDefaultRegion && bulkMessageData.camp_type === 'sms' && (
                <div>
                  <div className='form-check form-check-sm form-check-custom form-check-solid mt-2'>
                    <input
                      className='form-check-input me-5'
                      id='abtest'
                      type='checkbox'
                      data-kt-check='true'
                      checked={bulkMessageData.abTest}
                      disabled={userValues?.smsStatus !== 'approved'}
                      onChange={() => {
                        setBulkMessageData({
                          ...bulkMessageData,
                          abTest: !bulkMessageData.abTest,
                        })
                      }}
                    />
                    <div>
                      <div className='d-flex'>
                        <h5 style={{lineHeight: '0.65'}}>A/B Testing</h5>
                        <OverlayTrigger
                          placement='top'
                          overlay={<Tooltip>Contact Support to enable A/B Testing</Tooltip>}
                        >
                          {userValues?.smsStatus !== 'approved' ? (
                            <i
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              title='A/B Testing'
                              className='bi bi-question-circle-fill px-3 '
                            ></i>
                          ) : (
                            <></>
                          )}
                        </OverlayTrigger>
                      </div>
                      <p>Set A/B Testing for this campaign</p>
                    </div>
                  </div>
                </div>
              )}

              <MessageBoxV2
                error={error}
                setError={setError}
                setUserMessage={setBulkMessageData}
                userMessage={bulkMessageData}
                setOptions={setOptions}
                options={options}
                isDraft={true}
                isAlphaId={isCustomPriceOrAlphaId}
                showSelect={['template', 'customfield', 'weblink', 'landingPage', 'opt-out']}
                quickSms={bulkMessageData.camp_type === 'sms'}
                enableUnicodeModal={true}
              />

              {bulkMessageData.camp_type === 'sms' && bulkMessageData.abTest && (
                <MessageBoxSecond
                  error={error}
                  setError={setError}
                  setUserMessage={setBulkMessageData}
                  userMessage={bulkMessageData}
                  setOptions={setOptions}
                  options={options}
                  isDraft={true}
                  isAlphaId={isCustomPriceOrAlphaId}
                  showSelect={['template', 'customfield', 'weblink', 'landingPage', 'opt-out']}
                  quickSms={bulkMessageData.camp_type === 'sms'}
                />
              )}

              {bulkMessageData.autoResponder && (
                <div className='row'>
                  <div className='col-md-7 ps-14'>
                    <select name='selector' className='form-select bg-light-primary border-0  mt-3'>
                      <option value=''>Select your Automation</option>
                      <option value='1'>Reply Y</option>
                      <option value='2'>Any message</option>
                      <option value='3'>VIP</option>
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Bulk_Message_MesssageBox
